const STATUS_MAP = {
  Delivered: "success",
  paid: "success",
  Pending: "warning",
  Processing: "info",
  Canceled: "danger",
  Cancelled: "danger",
  Shipped: "info",
};

const StatusBadge = ({ status, variant }) => {
  const resolved = variant || STATUS_MAP[status] || "neutral";
  return <span className={`dashboard-badge dashboard-badge--${resolved}`}>{status || "—"}</span>;
};

export default StatusBadge;
